import classNames from 'classnames'
import React, { ReactElement } from 'react'
import { checkIfInputHasAnError } from 'apps/Onboarding/views/BlueBook/components/FiscalInfo/helpers'
import { composeValidators } from 'utils/validations'
import { Field, useField } from 'react-final-form'
import { getComponentByType } from 'components/Form/helpers'
import { getLabelAndplaceholder } from '../../helpers'
import { IDocumentsManualInfoInput } from '../../../../interface'
import { useTranslation } from 'react-i18next'

export const DocumentsManualInfoInput = ({ errors, field, touched }: IDocumentsManualInfoInput): ReactElement => {
  const { t } = useTranslation()
  const { name, type, validations } = field
  const { label, placeholder } = getLabelAndplaceholder(name, t)

  return (
    <div className='documents-manual-info-form-input'>
      <Field
        key={name}
        {...{ useField }}
        classNameFieldset={classNames('no-left-margin', {
          hasError: checkIfInputHasAnError(errors, name, touched)
        })}
        component={getComponentByType(type)}
        labelComponent='input'
        placeholder={placeholder}
        labelOptions={{
          colon: 'false',
          htmlFor: name,
          text: label
        }}
        name={name}
        type='text'
        validate={composeValidators(...validations)}
      />
    </div>
  )
}
